module.exports = "https://static.wmbcdn.com/uniweb/images/4743f9f96729dfb82b2e5746e5736232.svg";